<template>
  <div v-if="showmsg" :class="'message__' + type">
    <span v-show="showClose" class="message__close" @click="clicMsg"></span>
    <div :class="'message__text ' + align">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "message",
  props: {
    text: {
      type: String,
    },
    type: {
      type: String,
      default: "Fixed",
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    showmsg: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: "center",
    },
  },


  methods: {
    clicMsg() {
      this.$emit("clicMsg");
      console.log("clic");
      this.createTimeOut();
    },

    createTimeOut() {
      setTimeout(() => {
        this.showmsg = false;
        console.log("close");
      }, 1500);
    },
  },
};
</script>